import React, { Component } from 'react'

export default class index extends Component {
    render() {
        return (
            <div>
                <h1>Pending Deliveries</h1>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/pending-deliveries/index.js